import * as React from 'react';

import {
  ISimilarNewObjectEntitySchema,
  IAgentSchema,
  IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { isArrayWithItems } from '../../utils';
import * as styles from './index.css';
import { SimilarNewObjectsItem } from './item';

import { getVAS } from '../../utils/tracking';
import * as Analytics from '../../ebc/track_similar';

export interface ISimilarNewObjectsProps {
  agent: IAgentSchema | null;
  offer: IOfferSchema;
  similarNewObjects: ISimilarNewObjectEntitySchema[] | null;
  user: Analytics.IUserEBC;
  page: Analytics.IPageEBC;
}

export class SimilarNewObjects extends React.PureComponent<ISimilarNewObjectsProps, {}> {
  private container: HTMLElement | null;
  private productsEbc: Analytics.TProductPartial[];

  public componentDidMount() {
    if (isArrayWithItems<ISimilarNewObjectEntitySchema>(this.props.similarNewObjects)) {
      window.addEventListener('scroll', this.handleShow);
    }
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handleShow);
  }

  public render() {
    const { similarNewObjects } = this.props;

    if (!isArrayWithItems<ISimilarNewObjectEntitySchema>(similarNewObjects)) {
      return null;
    }

    return (
      <section
        className={styles['container']}
        ref={container => this.container = container}
      >
        <h2 className={styles['title']}>
          Новостройки в этом районе
        </h2>
        <ul className={styles['list']}>
          {similarNewObjects.slice(0, 5).map((item, index) =>
            <SimilarNewObjectsItem
              item={item}
              key={item.id || index}
              position={index + 1}
              onClick={this.handleClickOffer}
            />)
          }
        </ul>
      </section>
    );
  }

  private handleShow = () => {
    const { similarNewObjects, user, page } = this.props;

    if (this.container) {
      const containerPositionMiddle = this.container.offsetTop + (this.container.offsetHeight / 2);
      const windowScrollPosition = window.pageYOffset + window.innerHeight;

      if (isArrayWithItems<ISimilarNewObjectEntitySchema>(similarNewObjects) &&
        windowScrollPosition > containerPositionMiddle) {
        window.removeEventListener('scroll', this.handleShow);

        this.productsEbc = similarNewObjects.map((similarObject, index): Analytics.TProductPartial => {

          return {
            id: similarObject.id || undefined,
            position: index + 1,
            ownerId: similarObject.publishedUserId || undefined,
            variant: getVAS(similarObject.valueAddedServices),
          };
        });

        Analytics.trackOffersShow({
          action: Analytics.EtrackOffersShowActions.show_similar_newobjects,
          products: this.productsEbc,
          modelVersion: '0',
          user,
          page,
        });
      }
    }
  }

  private handleClickOffer = (curOffer: ISimilarNewObjectEntitySchema, position: number) => {
    const { agent, offer, user, page } = this.props;
    const products: Analytics.TProductPartial[] = [{
        id: curOffer.id || undefined,
        ownerId: curOffer.publishedUserId || undefined,
        position,
        variant: getVAS(curOffer.valueAddedServices),
      }];

    Analytics.trackOfferClick({
      action: Analytics.EtrackOfferClicksActions.click_similar_newobjects,
      products,
      agent,
      offer,
      modelVersion: '0',
      user,
      page,
    });
  }
}
